/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { getValue } from '@syncfusion/ej2-base';
import { Tooltip } from '@syncfusion/ej2-popups';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { format, parseISO } from 'date-fns';

import { ButtonComponent, SwitchComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Sort,
  Filter,
  Resize,
  Edit,
  Toolbar,
  PdfExport,
  ExcelExport,
  ForeignKey,
  LazyLoadGroup,
  VirtualScroll,
  Group,
} from '@syncfusion/ej2-react-grids';
import { UploaderComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useNavigate, Link } from 'react-router-dom';
import { DataManager, Query } from '@syncfusion/ej2-data';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import { AMap, GMap, Header, Heartbeat, Events, Configuration, Biometrics, DevLog, SSTEvents, DuressEvents } from '../components';
import orgpng from '../data/organization.png';
import lngpng from '../data/language.png';
import scribeHow from '../data/scribehow.png';

import { associatesGrid, gridNameHeader, gridNameProfile, gridTemperatureHeader, gridActivityHeader, gridRespiratoryHeader, gridRespiratoryProfile, gridBloodpressureHeader, gridFatigueHeader, gridHRVProfile, gridRiskHeader, gridEnvHeader, gridHeartrateHeader, gridHeartrateVariablilityHeader, gridHydrationProfile, gridActivityProfile, gridBloodpressureProfile, gridFatigueProfile, gridHeartrateProfile, gridHydrationHeader, gridManDownHeader, gridManDownProfile, gridOxygenHeader, gridOxygenProfile, gridTemperatureProfile, valueAccess } from '../data/dummy';

import './Zackat.css';
import profileImage from '../data/profile.png';

const AssociatesControlCenter = () => {
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const navigate = useNavigate();
  const {
    screenSize,
    setScreenSize,
    zRenderMode,
    isMobile,
    boss,
    setAIType,
    handleClick,
    setPatientId,
    reloadCounts,
    setReloadCounts,
  } = useStateContext();
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  const [enableEvents, setEvents] = useState(true);
  const [deleteAssociate, setDelete] = useState(true);
  const [enableCfg, setCfg] = useState(false);
  const [page, setPage] = useState(1);
  const [currentCount, setCurrentCount] = useState(50);
  const [limit, setLimit] = useState(0);
  const currentThemeColor = localStorage.getItem('colorMode');
  const timerid = useRef();
  const [condensed, setCondensed] = useState(false);
  const [muted, setMuted] = useState(false);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  const [isSST, setIsSST] = useState(false);
  const [isDuress, setIsDuress] = useState(false);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [colDisplay, setColDisplay] = useState(false);
  const [sortOptions, setSortColumns] = useState({});
  const [groups, setGroups] = useState([]);
  const [watches, setWatches] = useState([]);
  const [hypoColor, setHypoColor] = useState('transparent');
  const [baseColor, setBaseColor] = useState('transparent');
  const [moderateColor, setModerateColor] = useState('transparent');
  const [elevatedColor, setElevatedColor] = useState('transparent');
  const [severeColor, setSevereColor] = useState('transparent');
  const [selName, setName] = useState('');
  const [riskColor, setRiskColor] = useState('');
  const [envColor, setEnvColor] = useState('');
  const [selAddress, setAddress] = useState('');
  const [selAddress1, setAddress1] = useState('');
  const [selCity, setCity] = useState('');
  const [selState, setState] = useState('');
  const [selZip, setZip] = useState('');
  const [associate, setAssociate] = useState(null);
  const [associateid, setAssociateId] = useState(null);
  const [selectedAssociateRow, setAssociateRow] = useState(null);
  const [associatesearch, setAssociateSearch] = useState('');
  const [selVitals, setVitals] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selOrganization, setOrganization] = useState('');
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selLanguage, setLanguage] = useState('');
  const [selBundle, setBundle] = useState('');
  const [selEngineering, setEngineering] = useState(false);
  const [selRefresh, setRefresh] = useState('');
  const [selEmployeeImage, setEmployeeImage] = useState('');
  const [selMobile, setMobile] = useState('');
  const [selEmail, setEmail] = useState('');
  const [selReportsTo, setReportsTo] = useState('');
  const [selManagerId, setManagerId] = useState('');
  const [managers, setManagers] = useState([]);
  const [selJobTask, setJobTask] = useState('');
  const [taskData, setJobTasks] = useState([]);
  const [mgrData, setMgrData] = useState([]);
  const [getManager, setGetManager] = useState(false);
  const [selJobs, setJobs] = useState(false);
  const [selRisk, setRisk] = useState('');
  const [selEnvironment, setEnvironment] = useState('');
  const [selDob, setDob] = useState('');
  const [selAge, setAge] = useState('');
  const [selLat, setLat] = useState('');
  const [selLng, setLng] = useState('');
  const [smsOptin, setSMSOptin] = useState(false);
  const [emailOptin, setEmailOptin] = useState('');
  const [gender, setGender] = useState('');
  const [selTemperature, setTemperature] = useState('');
  const [selTemperatureBaseline, setTemperatureBaseline] = useState('');
  const [selHeartrate, setHeartrate] = useState('');
  const [selHeartrateBaseline, setHeartrateBaseline] = useState('');
  const [selOxygen, setOxygen] = useState('');
  const [selOxygenBaseline, setOxygenBaseline] = useState('');

  const [dataChanged, setDataChanged] = useState(false);
  const [biometricEnable, setBiometricEnable] = useState(false);
  const [smsEnable, setSmsEnable] = useState(false);
  const [recordingsEnable, setRecordingsEnable] = useState(false);
  const [inviteEnable, setInviteEnable] = useState(false);
  const { amapActive, setAmapActive } = useStateContext();

  // const selectionSettings = { mode: 'Row', type: 'Single' };
  const location = { text: 'Location', tooltipText: 'Associate Location', prefixIcon: 'e-expand', id: 'location', disabled: enableEvents };
  const charts = { text: 'Charts', tooltipText: 'Associate Charts', prefixIcon: 'e-chart-2d-line-100-stacked-line-with-markers', id: 'charts', disabled: enableEvents };
  const devlog = { text: 'DevLogs', tooltipText: 'Device DevLogs', prefixIcon: 'e-list-ordered', id: 'devlog', visible: boss, disabled: !boss };
  const events = { text: 'Events', tooltipText: 'Associate Events', prefixIcon: 'e-justify', id: 'events', disabled: enableEvents };
  const sst = { text: 'STT', tooltipText: 'Associate STT Events', prefixIcon: 'e-comments', id: 'sstevents', visible: isSST, disabled: enableEvents };
  const duress = { text: 'Duress', tooltipText: 'Associate Duress', prefixIcon: 'e-pan', id: 'duressevents', visible: isDuress, disabled: enableEvents };
  const alerts = { text: 'Alerts', tooltipText: 'Clear Alerts/Notifications', prefixIcon: 'e-link-remove', id: 'alerts', disabled: enableEvents, visible: !condensed };
  const invite = { text: 'Invite', tooltipText: 'MobileApp Invitation', prefixIcon: 'e-callout', id: 'invite', visible: inviteEnable, disabled: enableEvents };
  const ai = { text: 'AI', tooltipText: 'Predictive Analysis', prefixIcon: 'e-assistview-icon', id: 'ai', visible: boss, disabled: enableEvents };
  const mute = { text: 'Mute', tooltipText: 'Mute Vital Alerts (SMS/Emails)', prefixIcon: 'e-eye-slash', visible: !muted, id: 'mute', disabled: enableEvents };
  const unmute = { text: 'UnMute', tooltipText: 'Un-Mute Vital Alerts (SMS/Emails)', prefixIcon: 'e-eye', visible: muted, id: 'unmute', disabled: enableEvents };
  const cfg = { text: 'Configuration', tooltipText: 'Configuration', visible: enableCfg && crudCreate, prefixIcon: 'e-settings', id: 'config', disabled: !enableCfg };
  const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-plus', id: 'add', visible: crudCreate, disabled: false };
  const myedit = { text: 'Edit', tooltipText: 'Edit Associate', prefixIcon: 'e-edit', id: 'edit', visible: crudUpdate, disabled: enableEvents };
  const del = { text: 'Delete', tooltipText: 'Delete Associate', prefixIcon: 'e-delete-2', id: 'delete', visible: crudDelete, disabled: deleteAssociate };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: enableEvents, visible: !condensed };
  const toolbarOptions = [add, myedit, del, events, sst, location, charts, devlog, alerts, invite, ai, mute, unmute, cfg, excel, duress, 'Search'];
  const toolbarNoOptions = [invite, 'Search'];
  // 'PdfExport',
  let chartInstance;
  const handleCloseDialog = () => {
    setCfgDialog(!cfgDialog);
  };
  const [bundleData, setBundleData] = useState([]);
  // Optional: Persist selection across paging/sorting (requires a primary key)
  /*
  const selectionSettings = {
    type: 'Multiple',
    enableToggle: true,
    persistSelection: true,
  };
  */
  const dataBound = (args) => {
    if (grid && grid.current) {
      grid.current.toolbarModule.toolbar.overflowMode = 'PopUp';
    }
  };
  const calculateAge = () => {
    if (selDob && selDob !== '') {
      const today = new Date();
      const birthDateObj = new Date(selDob);
      let calculatedAge = today.getFullYear() - birthDateObj.getFullYear();
      const monthDiff = today.getMonth() - birthDateObj.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        calculatedAge -= 1;
      }
      return calculatedAge;
    }
    return '';
  };
  const primaryxAxis = { minimum: 0, maximum: 11, interval: 1, title: 'Risk' };
  const primaryyAxis = {
    title: 'Percentage',
    minimum: 0,
    maximum: 100,
    labelFormat: '{value}%',
  };
  const tooltip = {
    enable: true,
    fill: '#78DA89',
    border: {
      width: 2,
      color: '#383838',
    },
  };
  const titlestyle = {
    color: '#383838',
  };
  const bardata = [
    { x: 1, y: 28 },
  ];
  const grid = useRef(null);
  const searchThis = (args) => {
    if (grid && grid.current) {
      const search = document.getElementById('associatesearch');
      if (search) {
        if (search.value.includes('.')) {
          dialogClick('na', 'Associate Search Query', 'Please do not use the reserved period (.) character!', null);
          return;
        }
        //        grid.current.search(search.value);
        setAssociateSearch(search.value);
      } else {
        setAssociateSearch('');
      }
    }
    setAssociateRow(1);
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };
  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };

  function setDateOfBirth(e) {
    setDob(e.value);
  }
  const eventTemplate = () => (
    <Events props={associate} />
  );
  const sstEventTemplate = () => (
    <SSTEvents props={associate} />
  );
  const duressEventTemplate = () => (
    <DuressEvents props={associate} />
  );
  const memoizedData = useMemo(() => associate, [associate]);
  /*
  const cfgTemplate = () => {
    if (associate && associate.name) {
      return <Configuration dt={memoizedData} />;
    }
  };
  */
  // 2. Wrap the template function in useCallback
  const cfgTemplate = useCallback(() => {
    if (memoizedData && memoizedData.name) {
      return <Configuration dt={memoizedData} />;
    }
    return null; // Always return null or fallback UI if data isn't ready
  }, [memoizedData]); // Only changes if memoizedData changes

  const gmapTemplate = () => (
    <GMap props={associate} />
  );
  const chartTemplate = () => (
    <Heartbeat props={associate} />
  );
  const devlogTemplate = () => (
    <DevLog props={associate} />
  );

  const profileTemplate = () => (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <form>
        <table className="biotable" style={{ width: '100%' }}>
          <tbody>
            <tr>
              <th style={{ backgroundColor: hypoColor }}><font color="blue">HYPO</font></th>
              <th style={{ backgroundColor: baseColor }}><font color="green">BASELINE</font></th>
              <th style={{ backgroundColor: moderateColor }}><font color="yellow">MODERATE</font></th>
              <th style={{ backgroundColor: elevatedColor }}><font color="orange">ELEVATED</font></th>
              <th style={{ backgroundColor: severeColor }}><font color="red">SEVERE</font></th>
            </tr>
          </tbody>
        </table>
        {associateid !== 'add_associate' && (
          <div className="control-section accordion-control-section">
            <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
              <AccordionComponent multiple>
                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                  <div className="e-input-group">
                    <div className="mt-4"> Vitals </div>
                  </div>
                  <div className="mt-2 e-input-group">
                    <TextBoxComponent multiline htmlAttributes={multilineAttributes} value={selVitals} title="vital readings" cssClass={riskColor} readOnly floatLabelType="Never" onChange={() => { }} />
                  </div>
                </div>
              </AccordionComponent>
            </div>
          </div>
        )}
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Risk" value={selRisk} title="Calculated based on baseline, and vitals readings" disabled cssClass={riskColor} readOnly floatLabelType="Auto" onChange={() => { }} />
            <TextBoxComponent placeholder="Environment" title="Calculated based on climate conditions" value={selEnvironment} disabled cssClass={envColor} readOnly floatLabelType="Auto" onChange={() => { }} />
          </div>
        </div>
        {associateid !== 'add_associate' && (
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
            <div className="e-input-group">
              <img src={selEmployeeImage} className="w-10 h-10" value={selName} id={associateid} />
              <input type="file" name="userfile" id={associateid} onChange={handleChange} />
            </div>
          </div>
        )}
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Name"
              title="Associate Name"
              value={selName}
              cssClass="e-error e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setName(v.value); }}
            />
            {/*
            <TextBoxComponent placeholder="Reports To" title="Controlled via Manager tab" disabled value={selReportsTo} cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setReportsTo(v.value); }} />
            <TextBoxComponent placeholder="Job/Task" title="Controlled via Manager tab" value={selJobTask} cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setJobTask(v.value); }} />
            */}
            <MultiSelectComponent id="ddlreport" dataSource={mgrData} fields={{ value: '_id', text: 'name' }} cssClass="e-outline" disabled={associateid === 'add_associate'} floatLabelType="Auto" mode="CheckBox" value={managers} onChange={saveManagers} placeholder="Select Manager">
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
            <DropDownListComponent id="ddljob" cssClass="e-outline" floatLabelType="Auto" dataSource={taskData} fields={{ value: 'id', text: 'text' }} placeholder="Select Task" value={selJobTask} onChange={(v) => { setJobTask(v.value); }} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Enter Address" value={selAddress} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress(v.value); }} />
            <TextBoxComponent placeholder="Enter Address cont." value={selAddress1} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress1(v.value); }} />
          </div>
        </div>

        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Enter City" value={selCity} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setCity(v.value); }} />
            <TextBoxComponent placeholder="Enter State" value={selState} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setState(v.value); }} />
            <TextBoxComponent placeholder="Enter Zip" value={selZip} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setZip(v.value); }} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Mobile" value={selMobile} type="text" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMobile(v.value); }} />
            <TextBoxComponent placeholder="Email Address" value={selEmail} type="email" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setEmail(v.value); }} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Device" width={250} title="SIM Device Identification" showClearButton value={selDevice} type="text" cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setDevice(v.value); }} />
          </div>
        </div>

        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6 mb-4">
          <div className="e-input-group">
            <CheckBoxComponent label="SMS OpIin" title="Controlled via mobile App" disabled checked={smsOptin} />
            <CheckBoxComponent label="Email OptIn" title="Controlled via mobile App" disabled checked={emailOptin} />
            {boss && <CheckBoxComponent label="Engineering Use Only" checked={selEngineering} change={(v) => { setEngineering(v.checked); }} />}
            {boss && <TextBoxComponent placeholder="Refresh Rate" floatLabelType="Auto" width={150} title="Refresh Rate" showClearButton value={selRefresh} type="text" cssClass="e-outline" onChange={(v) => { setRefresh(v.value); }} />}
          </div>
        </div>
        <div className="row custom-margin">
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-6">
            <div className="e-input-group">
              <DatePickerComponent id="dob" cssClass="e-outline" floatLabelType="Auto" change={setDateOfBirth} onChange={setDateOfBirth} placeholder="Date of Birth M/D/YYYY" value={selDob} />
              <TextBoxComponent placeholder="Age" width={100} title="Calculated from Date of Birth" value={calculateAge(selDob)} type="text" disabled cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAge(v.value); }} />
              <div className="row">
                <RadioButtonComponent label="Male" name="gender" value="male" checked={gender === 'male'} onChange={(v) => { setGender(v.value); }} />
              </div>
              <div className="row">
                <RadioButtonComponent label="Female" name="gender" value="female" checked={gender === 'female'} onChange={(v) => { setGender(v.value); }} />
              </div>
            </div>
          </div>
        </div>
        <div className="row custom-margin">
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
            <div className="e-input-group mt-6">
              <DropDownListComponent id="ddlelement" floatLabelType="Auto" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
              <DropDownListComponent id="ddllanguage" floatLabelType="Auto" cssClass="e-outline" dataSource={langParams.params.dataSource} fields={langParams.params.fields} placeholder="Select Language" value={selLanguage} onChange={(v) => { setLanguage(v.value); }} />
              <DropDownListComponent id="ddlbundle" floatLabelType="Auto" cssClass="e-outline" dataSource={bundles.params.dataSource} fields={bundles.params.fields} placeholder="Select AlertBundle" value={selBundle} onChange={(v) => { setBundle(v.value); }} />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
  function saveManagers(e) {
    setManagers(e.value);
  }

  let dialogInstance;

  function dialogOK(f, e) {
    dialogInstance.hide();
    if (f === 'recording') {
      recordingDevice(e);
    } else if (f === 'sms') {
      smsDevice(e);
    } else if (f === 'mute') {
      silenceDevice(true);
    } else if (f === 'unmute') {
      silenceDevice(false);
    }
  }
  function dialogClick(f, hdr, content, e) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, e); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'Associate Row', 'No associate selected', null);
          return;
        }
      }
    }

    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  const addProfile = () => {
    if (!selOrganization || selOrganization.length === 0) {
      dialogClick('na', 'Associate Organization', 'Required, please select an Organization for the Associate!', null);
      return;
    }
    const result = orgData.find(({ id }) => id === selOrganization);
    const newassociate = {};
    newassociate.organizationid = selOrganization;
    newassociate.organization = result.value;
    newassociate.language = 'en-US';
    if (selLanguage && selLanguage.length > 0) {
      const lresult = langData.find(({ id }) => id === selLanguage);
      newassociate.language = lresult.id;
    }
    if (selBundle && selBundle.length > 0) {
      const lresult = bundleData.find(({ _id }) => _id === selBundle);
      newassociate.alertBundle = lresult._id;
    }
    // Set Initial HIPAA
    const currentDate = new Date();
    const isoString = currentDate.toISOString();
    newassociate.hipaa = { consent: true, timestamp: isoString, version: 'created' };
    newassociate.managers = [];
    if (!selName || selName.length == 0) {
      dialogClick('na', 'Associate Name', 'Required, please enter a name for the Associate!', null);
      return;
    }
    if (selDevice && selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      dialogClick('na', 'Associate Profile', `Please provide a valid device for the associate ${selDevice}!`, null);
      return;
    }

    newassociate.name = selName;
    newassociate.device = selDevice;
    if (selMobile && selMobile.length > 0) {
      newassociate.mobile = selMobile.replace(/\D/g, '');
      if (newassociate.mobile.length >= 10) {
        newassociate.mobile = newassociate.mobile.substring(newassociate.mobile.length - 10);
      }
    }
    if (selEmail.length > 0 && !selEmail.includes('@') && !selEmail.includes('.')) {
      dialogClick('na', 'Associate Profile', 'Please provide a valid email for the associate!', null);
      return;
    }

    newassociate.email = selEmail;
    newassociate.address = selAddress;
    newassociate.address1 = selAddress1;
    newassociate.city = selCity;
    newassociate.state = selState;
    newassociate.zip = selZip;
    if (selDob !== '') {
      newassociate.dob = new Date(selDob).toLocaleDateString();
    } else {
      newassociate.dob = '';
    }
    if (gender === 'male') {
      newassociate.gender = 'male';
    } else if (gender === 'female') {
      newassociate.gender = 'female';
    } else {
      newassociate.gender = '';
    }
    newassociate.refresh = selRefresh;
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newassociate),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newassociate._id = responseJson._id;
          setAssociateId(newassociate._id);
          setPatientId(newassociate._id);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'New Associate handler', responseJson.response, null);
        }
        if (!timerid.current) {
          timerid.current = setTimeout(timerid.current, 30000);
        }
        setDialog(!hideDialog);
        setReload(!reload);
        setReloadCounts(reloadCounts + 1);
      })
      .catch((error) => {
        dialogClick('na', 'Associate Add', 'An error has occured during New Associate Insert!', null);
      });
  };
  const saveProfile = () => {
    if (associate.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Associate ${associate.name} from ${associate.organization} to ${result.value}`)) {
        return;
      }
      associate.organizationid = selOrganization;
      associate.organization = result.value;
    }
    if (associate.language !== selLanguage) {
      const result = langData.find(({ id }) => id === selLanguage);
      associate.language = result.id;
    }
    if (selBundle && selBundle.length > 0) {
      const lresult = bundleData.find(({ _id }) => _id === selBundle);
      associate.alertBundle = lresult._id;
    } else {
      associate.alertBundle = '';
    }

    if (selName.length === 0) {
      dialogClick('na', 'Associate Profile', 'Please provide a name for the associate!', null);
      return;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      dialogClick('na', 'Associate Profile', 'Please provide a device for the associate!', null);
      return;
    }
    if (selEmail.length > 0 && !selEmail.includes('@') && !selEmail.includes('.')) {
      dialogClick('na', 'Associate Profile', 'Please provide a valid email for the associate!', null);
      return;
    }
    associate.name = selName;
    associate.device = selDevice;
    if (selMobile && selMobile.length > 0) {
      associate.mobile = selMobile.replace(/\D/g, '');
      if (associate.mobile.length >= 10) {
        associate.mobile = associate.mobile.substring(associate.mobile.length - 10);
      }
    }
    associate.email = selEmail;
    associate.address = selAddress;
    associate.address1 = selAddress1;
    associate.city = selCity;
    associate.state = selState;
    associate.zip = selZip;
    associate.jobtask = selJobTask;
    associate.engineering = selEngineering;
    associate.refresh = selRefresh;

    associate.managerid = selManagerId;
    if (!managers) {
      associate.managers = [];
    } else {
      associate.managers = managers;
    }
    if (selDob) { // && selDob !== 'Invalid Date' && selDob.length > 0 && selDob !== 'undefined') {
      associate.dob = new Date(selDob).toLocaleDateString();
    } else {
      associate.dob = '';
    }
    if (gender === 'male') {
      associate.gender = 'male';
    } else if (gender === 'female') {
      associate.gender = 'female';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(associate),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Associate Update', `${selName} Profile saved!`, null);
        setDialog(!hideDialog);
        if (!timerid.current) {
          timerid.current = setTimeout(timerid.current, 30000);
        }
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Associate Update', 'An error has occured during Update!', null);
      });
  };

  const onToolbarChange = (args) => {
    if (grid && grid.current) {
      const selectedRow = grid.current.getSelectedRecords()[0];
      if (args.target.textContent === 'Update') {
        grid.current.endEdit();
      }
      if (args.target.textContent === 'Edit') {
        grid.current.startEdit();
      }
      if (args.target.textContent === 'Delete') {
        grid.current.deleteRecord(selectedRow);
      }
      if (args.target.textContent === 'Add') {
        grid.current.addRecord();
      }
      if (args.target.textContent === 'Raw Events') {
        const selectedRecords = grid.current.getSelectedRecords();
        if (!selectedRecords || selectedRecords.length === 0) {
          dialogClick('na', 'Select Associate', 'Required, Please select an associate!', null);
          return;
        } if (selectedRecords && selectedRecords.length === 1) {
          navigate(`../basic?id=${selectedRecords[0]._id}&lat=${selectedRecords[0].latlng.latitude}&lng=${selectedRecords[0].latlng.longitude}&name=${selectedRecords[0].name}&tabNo=0`);
        } else {
          dialogClick('na', 'Select Associate', 'Required, Please select only one associate!', null);
          return;
        }
      }
      if (args.target.textContent === 'Events') {
        navigate(`../events?id=${selectedRow._id}&lat=${selectedRow.latlng.latitude}&lng=${selectedRow.latlng.longitude}&name=${selectedRow.name}`);
      }
      if (args.target.textContent === 'Location') {
        navigate(`../basic?id=${selectedRow._id}&lat=${selectedRow.latlng.latitude}&lng=${selectedRow.latlng.longitude}&name=${selectedRow.name}&tabNo=1`);
      }
      if (args.target.textContent === 'Charts') {
        navigate(`../basic?id=${selectedRow._id}&lat=${selectedRow.latlng.latitude}&lng=${selectedRow.latlng.longitude}&name=${selectedRow.name}&tabNo=2`);
      }
      if (args.target.textContent === 'PDF Export') {
        const properties = {
          fileName: `PDFExport_Associates_${associate.name}_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
        };
        grid.current.pdfExport(properties);
      }
      if (args.target.textContent === 'Excel Export') {
        const properties = {
          fileName: `ExcelExport_Associates_${associate.name}_${new Date().toISOString()}.xlsx`,
        };
        grid.current.excelExport(properties);
      }
    }
  };
  const actionData = [
    { text: 'Not specified', value: 'na' },
    { text: 'Check In', value: '"checkin":"query"' },
    { text: 'Development', value: '"srvr":{"url":"biometric.zackat.com", "port": "10900"}' },
    { text: 'FOTA', value: '"fota":"ind"' },
    { text: 'Locate', value: '"locate":"query"' },
    { text: 'Production', value: 'srvr":{"url":"bio.zackatlabs.com", "port": "10900"}' },
    { text: 'Restart', value: '"reset":"restart"' },
    { text: 'Sleep', value: '"reset":"sleep"' },
    { text: 'SMS', value: '""' },
    { text: 'Staging', value: '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}' },
  ];
  const [actions, setActions] = useState(actionData);

  const [selectedOption, setSelectedOption] = useState(actionData[0]);
  const actionComponent = () => (
    <div>
      <DropDownListComponent id="ddlelement" dataSource={actions} placeholder="Device Action" value={selectedOption} onChange={(e) => { dialogClick('sms', 'Send Device Action', `Would you lke to send this action ${e.target.itemData.text}?`, e); }} />
    </div>
  );
  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);
  const audioComponent = () => (
    <div>
      <DropDownListComponent dataSource={audioData} placeholder="Send Recording" value={selectedAudioOption} onChange={(e) => { dialogClick('recording', 'Send Recording', `Would you lke to send this recording ${e.target.itemData.text}?`, e); }} />
    </div>
  );

  const biometricsComponent = () => (
    <div>
      <div>
        <label htmlFor="showDisplay">
          Biometrics&nbsp;
        </label>
        <SwitchComponent id="showDisplay" checked={colDisplay} cssClass="bar-color handle-color" onChange={changeColDisplay} />
        <label htmlFor="showCondensed">
          Condensed&nbsp;
        </label>
        <SwitchComponent id="showCondensed" checked={condensed} cssClass="bar-color handle-color" onChange={changeCondensed} />
      </div>
    </div>
  );
  const pageComponent = () => (
    <div style={{ float: 'left', width: '200px' }}>
      <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
        <label htmlFor="showLimit" style={{ padding: '10px 40px 10px 0' }}>
          {selectedAssociateRow}-{currentCount} / {currentCount < 50 ? currentCount : associateCount}
        </label>
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-first-page" onClick={() => { setPage(1); setAssociateRow(1); }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-left" onClick={() => { let p = page; if (p !== 1) { setPage(p -= 1); setAssociateRow(1); } }} />
        &nbsp;&nbsp;Page {page} of {currentCount < 50 && page === 1 ? Math.ceil(currentCount / 50) : Math.ceil(associateCount / 50)}&nbsp;&nbsp;
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-right" onClick={() => { let p = page; let cnt = associateCount; if (currentCount < 50) { cnt = currentCount; } if (p !== Math.ceil(cnt / 50) && p !== Math.ceil(associateCount / 50)) { setPage(p += 1); setAssociateRow(1); } }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-last-page" onClick={() => { setPage(Math.ceil(associateCount / 50)); setAssociateRow(1); }} />
      </div>
    </div>
  );
  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <TextBoxComponent
        placeholder="name, device, msn"
        value={associatesearch}
        width="200px"
        required
        id="associatesearch"
        showClearButton
        cssClass="e-outline"
        floatLabelType="Never"
        onChange={(v) => { if (v.value.length === 0) { setAssociateSearch(''); } }}
        onKeyDown={handleKeyDown}
      />
      <button type="button" className="absolute right-0 top-0 mt-5 mr-8" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );
  const langData = [
    { value: 'English', id: 'en-US' },
    { value: 'German', id: 'de-DE' },
    { value: 'French', id: 'fr-FR' },
    { value: 'French (Canadian)', id: 'fr-CA' },
    { value: 'Spanish (US)', id: 'es-US' },
    { value: 'Spanish', id: 'es-ES' },
    { value: 'Portugese (Brazil)', id: 'pt-BR' },
    { value: 'Portugese (Portugal)', id: 'pt-PT' },
    { value: 'Danish', id: 'da-DK' },
    { value: 'Dutch', id: 'nl-NL' },
    { value: 'Austrailian', id: 'en-AU' },
    { value: 'English (British)', id: 'en-GB' },
    { value: 'English (India)', id: 'en-IN' },
    { value: 'English (Welsh)', id: 'en-GB-WLS' },
    { value: 'Icelandic', id: 'is-IS' },
    { value: 'Italian', id: 'it-IT' },
    { value: 'Japnense', id: 'ja-JP' },
    { value: 'Korean', id: 'ko-KR' },
    { value: 'Norweigan', id: 'nb-NO' },
    { value: 'Polish', id: 'pl-PL' },
    { value: 'Romanian', id: 'ro-RO' },
    { value: 'Russian', id: 'ru-RU' },
    { value: 'Swedish', id: 'sv-SE' },
    { value: 'Turkish', id: 'tr-TR' },
    { value: 'Welsh', id: 'cy-GB' },
    { value: 'Chinese (Simplified)', id: 'zh-CN' },
    { value: 'Chinese (Traditional)', id: 'zh-TW' },
  ];

  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hideDialog, setDialog] = useState(true);
  const [eventDialog, setEventDialog] = useState(true);
  const [sstEventDialog, setSSTEventDialog] = useState(true);
  const [duressEventDialog, setDuressEventDialog] = useState(true);
  const [cfgDialog, setCfgDialog] = useState(true);
  const [gmapDialog, setGMapDialog] = useState(true);
  const [chartsDialog, setChartsDialog] = useState(true);
  const [devlogDialog, setDevlogDialog] = useState(true);
  const handleDialogClick = () => {
    setDialog(!hideDialog);
  };
  const handleEventDialogClick = () => {
    setEventDialog(!eventDialog);
  };
  const handleSSTEventDialogClick = () => {
    setSSTEventDialog(!sstEventDialog);
  };
  const handleDuressEventDialogClick = () => {
    setDuressEventDialog(!duressEventDialog);
  };
  const handleCfgDialogClick = () => {
    setCfgDialog(!cfgDialog);
  };
  const handleGMapDialogClick = () => {
    setGMapDialog(!gmapDialog);
  };
  const handleChartsDialogClick = () => {
    setChartsDialog(!chartsDialog);
  };
  const handleDevLogDialogClick = () => {
    setDevlogDialog(!devlogDialog);
  };
  const dialogClose = () => {
    setDialog(true);
  };
  const animationSettings = { effect: 'FlipYLeft' };
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.sms && mydata.sms.length > 0) {
        const mysms = [];
        mydata.sms.forEach((e) => {
          const s = { text: e.name, value: e.syntax };
          mysms.push(s);
        });
        setActions(mysms);
      }
    };
    smsFetch();
  }, [reload]);

  const header = () => (
    <div><h1>{associateid === 'add_associate' ? 'Add' : 'Edit'} Associate {selName}</h1></div>
  );
  const chartbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleChartsDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const devlogbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDevLogDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const gmapbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleGMapDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const cfgbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleCfgDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const eventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: (e) => {
        if (e.action !== 'enter') {
          handleEventDialogClick();
        }
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const ssteventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleSSTEventDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const duresseventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDuressEventDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  const savebuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        addProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];

  function rowDataBound(args) {
    if (args.row) {
      if (getValue('risk', args.data) > 80 || args.data.temperature.reading > 100) {
        args.row.classList.add('rowcellred');
      } else if (getValue('risk', args.data) > 50) {
        args.row.classList.add('rowcellylw');
      } else {
        args.row.classList.add('rowcellgrn');
      }
    }
  }

  useEffect(() => {
    if (associate && associate.organizationid && associate.organizationid.length > 0) {
      usr.organizationid = associate.organizationid;
      usr.organization = associate.organization;
    }
    const getJobsData = async () => {
      if (!associate || !associate.organizationid) {
        return;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}&orgid=${associate.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let myjobs = [];
          if (mydata && mydata.tasks && mydata.tasks.length > 0) {
            myjobs = mydata.tasks;
          }
          setJobTasks(myjobs);
          setJobs(true);
          setGetManager(!getManager);
        })
        .catch((error) => {
          setJobTasks([]);
          setJobs(false);
        });
    };
    getJobsData();
  }, [selectedAssociateRow]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const bundleFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/alerts?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      const mybundles = [{ _id: '', name: 'N/A' }];
      if (mydata && mydata.alerts) {
        const selectedArray = mydata.alerts.map((alert) => ({
          _id: alert._id,
          name: alert.name,
        }));
        mybundles.push(...selectedArray);
      }
      setBundleData(mybundles);
    };
    bundleFetch();
  }, []);

  useEffect(() => {
    const getManagerData = async () => {
      if (!associate || !associate.organizationid) {
        return;
      }

      if (associate && associate.organizationid && associate.organizationid.length > 0) {
        usr.organizationid = associate.organizationid;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${associate.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let mymgr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            mymgr = mydata;
          }
          setMgrData(mymgr);
        })
        .catch((error) => {
          setMgrData([]);
        });
    };
    getManagerData();
  }, [getManager]);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 50;
    let p = 0;
    if (page > 1) {
      p = page - 1;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/associates?${query}&skip=${p * 50}`;
      setLoading(true);
      if (associatesearch && associatesearch.length > 0) {
        url = `${REACT_APP_API_ENDPOINT}/associates?${query}&skip=${p * 50}&search=${associatesearch}`;
      }
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          if (!mydata.associates) {
            mydata.associates = [];
          }
          if (mydata.user && mydata.user.preferences && mydata.user.preferences.associates) {
            if (mydata.user.preferences.associates.group) {
              const grp = mydata.user.preferences.associates.group;
              setGroups(grp);
            } else {
              setGroups(['organizationid']);
            }
            if (mydata.user.preferences.associates.biometrics) {
              const b = mydata.user.preferences.associates.biometrics;
              setColDisplay(b);
            }
            if (mydata.user.preferences.associates.condensed) {
              const b = mydata.user.preferences.associates.condensed;
              setCondensed(b);
            }
            if (mydata.user.preferences.associates.sort && mydata.user.preferences.associates.sort[0] && mydata.user.preferences.associates.sort[0].direction) {
              const mysortedColumns = { columns: mydata.user.preferences.associates.sort };
              setSortColumns(mysortedColumns);
            }
            if (mydata.user.preferences.associates) { // && mydata.user.preferences.associates.limit) {
              setLimit(mydata.user.preferences.associates.limit);
            }
            if (mydata.role && mydata.role.associates && mydata.role.associates.permissions && mydata.role.associates.permissions.includes('Biometrics')) {
              setBiometricEnable(true);
            }
            if (mydata.role && mydata.role.associates && mydata.role.associates.permissions && mydata.role.associates.permissions.includes('SMS')) {
              setSmsEnable(true);
            }
            if (mydata.role && mydata.role.associates && mydata.role.associates.permissions && mydata.role.associates.permissions.includes('Recordings')) {
              setRecordingsEnable(true);
            }
            if (mydata.role && mydata.role.associates && mydata.role.associates.permissions && mydata.role.associates.permissions.includes('Invite')) {
              setInviteEnable(true);
            }
            if (mydata.user.watch) {
              const { watch } = mydata.user;
              setWatches(watch);
            } else {
              setWatches([]);
            }
          } else {
            setGroups(['organizationid']);
          }
          if (mydata && mydata.associates) {
            setCurrentCount(mydata.associates.length);
            mydata.associates.forEach((a) => {
              if (a.resultField && a.resultField.length > 0 && a.resultField[0].msn) {
                a.msn = a.resultField[0].msn;
              }
            });
          }
          setData(mydata);
          setLoading(false);
        })
        .catch(() => {
        });
    };
    dataFetch();
    return () => {
      timerid.current = clearTimeout(timerid.current);
    };
  }, [reload, page, associatesearch]);

  const { activeMenu, associateCount, collapseConfiguration, setCollapseConfiguration } = useStateContext();
  function formatPhoneNumber(phoneNumberString) {
    if (!phoneNumberString || phoneNumberString.length <= 0) {
      return null;
    }
    if (phoneNumberString && phoneNumberString.length === 10) {
      phoneNumberString = `1${phoneNumberString}`;
    }
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const gridLangHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={lngpng}
        alt="language"
      />
      <pre>Language</pre>
    </div>
  );
  const groupOptions = {
    enableLazyLoading: true,
    columns: groups,
  };
  const [file, setFile] = useState();
  const orgData = [];
  const langParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(langData),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const bundles = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(bundleData),
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };
  const teamParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager([
        { TeamDescr: 'Team 1', id: '1' },
        { TeamDescr: 'Team 2', id: '2' },
        { TeamDescr: 'Team 3', id: '3' },
      ]),
      fields: { text: 'TeamDescr', value: 'id' },
      query: new Query(),
    },
  };
  const actionParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(actionData),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const handleWatchChange = (e) => {
    // e.event.preventDefault();
    if (associate) {
      associate.watch = e.checked;
    }

    if (!associate || associate._id.length === 0) {
      // DialogUtility.alert('Please select an Associate!');
      // return;
    }
    const newWatches = [...watches]; // Create a shallow copy
    if (!e.checked) {
      newWatches.splice(e.target.id, 1); // Mutate the copy
    } else {
      newWatches.push(e.target.id);
    }
    setWatches(newWatches); // Update state with the new array
  };
  const handleChange = (e) => {
    let upData = null;
    for (let idx = 0; idx < data.associates.length; idx += 1) {
      if (data.associates[idx]._id === e.target.id) {
        upData = data.associates[idx];
        break;
      }
    }
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (upData !== null) {
      filedata.append('_id', upData._id);
      filedata.append('fileName', e.target.files[0].name);
    } else {
      dialogClick('na', 'Photo Upload error', 'no photo data available', null);
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        setDialog(!hideDialog);
        dialogClick('na', 'Associate Photo Uploaded', '', null);
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Associate Photo Upload', 'An error has occured during Photo upload!', null);
      });
  };
  function removePhoto(e) {
    let removeData = null;
    for (let idx = 0; idx < data.associates.length; idx += 1) {
      if (data.associates[idx]._id === e.target.id) {
        removeData = data.associates[idx];
        break;
      }
    }
    if (removeData == null || confirm(`Remove photo for ${removeData.name}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          setReload(!reload);
        })
        .catch((error) => {
          dialogClick('na', 'Associate Photo Remove', 'An error has occured during Photo removal!', null);
        });
    }
  }
  const gridAssociateProfile = (props) => (
    <div className={`flex items-center gap-2 center 
      ${((props.activity && props.activity.alert && props.activity.alert.length > 0)
        || (props.heartrate && props.heartrate.alert && props.heartrate.alert.length > 0)
        || (props.bloodpressure && props.bloodpressure.alert && props.bloodpressure.length > 0)
        || (props.hydration && props.hydration.alert && props.hydration.alert.length > 0)
        || (props.temperature && props.temperature.alert && props.temperature.alert.length > 0)
        || (props.oxygen && props.oxygen.alert && props.oxygen.alert.length > 0)
        || (props.respiratory && props.respiratory.alert && props.respiratory.alert.length > 0)
        || (props.hrv && props.hrv.alert && props.hrv.alert.length > 0)) ? 'rowcellred' : 'rowcellgrn'}`}
    >
      {!props.employeeImage
        ? null
        : (
          <div>
            <img
              className="rounded-full w-10 h-10"
              src={props.employeeImage ? props.employeeImage : profileImage}
              alt="employee"
            />
            <font color="black"><input type="submit" name="remove" id={props._id} value="&#x007F;" onClick={removePhoto} /></font>
            <br /><Link to={`tel:${props.mobile}`} style={{ textDecoration: 'underline !important' }}>{formatPhoneNumber(props.mobile)}</Link>{/* backgroundColor: 'white', color: '#78DA89', */}
          </div>
        )}
    </div>
  );
  const gridImageHeader = () => (
    <div className="w-10">
      <img
        className="w-10 h-10"
        src={profileImage}
      />
      <pre>Image</pre>
    </div>
  );
  let myScreenSize = 'auto';
  useEffect(() => {
    if (collapseConfiguration === true) {
      setCfgDialog(!cfgDialog);
      setReload(!reload);
    }
  }, [collapseConfiguration]);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    if (crudCreate && !enableEvents) {
      setCfg(true);
    }
    return () => {
      window.removeEventListener('resize', handleResize);
      setAssociateId('');
      setPatientId('');
      setAmapActive(false);
    };
  }, [enableEvents]);
  function customiseCell(args) {
    if (!args || !args.column || !args.column.headerText || args.column.headerText !== 'Risk') {
      return null;
    }
    const content = Biometrics(args);
    const thistooltip = new Tooltip({
      width: '400px',
      height: '200px',
      // <img src=${heartrate} style="display: inline-block;" width="30px" height="30px" />
      // ${args.data.bloodpressure ? args.data.bloodpressure.reading : ''}<sub class="supsm">sys/dia</sub>${bpflag}
      content,
    });
    if (colDisplay) {
      thistooltip.appendTo(args.cell);
    }
  }
  /*
  function customiseCell(args) {
    if (args.column.field === 'risk') {
      let tflag = '';
      let oflag = '';
      let hflag = '';
      let bpflag = '';
      let hrflag = '';
      let hrvflag = '';
      let rrflag = '';
      if (args.data.temperature && args.data.temperature.alert && args.data.temperature.alert !== '') {
        tflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.heartrate && args.data.heartrate.alert && args.data.heartrate.alert !== '') {
        hrflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.bloodpressure && args.data.bloodpressure.alert && args.data.bloodpressure.alert !== '') {
        bpflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.oxygen && args.data.oxygen.alert && args.data.oxygen.alert !== '') {
        oflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hydration && args.data.hydration.alert && args.data.hydration.alert !== '') {
        hflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.respiratory && args.data.respiratory.alert && args.data.respiratory.alert !== '') {
        rrflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hrv && args.data.hrv.alert && args.data.hrv.alert !== '') {
        hrvflag = '<font color="red">&#10003;</font>';
      }
      // const temp = args.data.temperature.reading;
      // const hydration = args.data.hydration.reading;
      let set = false;
      let riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      if (args.data.risk < 0) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellblue');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th bgcolor="cyan"><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk === '' || args.data.risk < 25) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellgrn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font><th><th  bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 50) {
        // args.cell.classList.add('riskbelow-80');
        args.cell.classList.add('rowcellylw');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font><th><th bgcolor="cyan"><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 80) {
        args.cell.classList.add('rowcellorn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font><th><th bgcolor="cyan"><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else {
        // args.cell.classList.add('riskabove-80');
        args.cell.classList.add('rowcellred');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font><th><th bgcolor="cyan"><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      }
      // Universal AQI
      // Code: uaqi
      // Pollutants: "co", "no2", "o3", "pm10", "pm25", "so2"
      // 100 - 80 Excellent air quality
      // 79 - 60 Good air quality
      // 59 - 40 Moderate air quality
      // 39 - 20 Low air quality
      // 19 - 1 Poor air quality
      // 0 Poor air quality

      if (!set && args.data.environment < 20) {
        args.cell.classList.add('aqi20');
      } else if (!set && args.data.environment < 40) {
        args.cell.classList.add('aqi40');
      } else if (!set && args.data.environment < 60) {
        args.cell.classList.add('aqi60');
      } else if (!set && args.data.environment < 80) {
        args.cell.classList.add('aqi80');
      } else if (!set) {
        args.cell.classList.add('aqi100');
      }
      let bhrv = '';
      let bhr = '';
      let btemp = '';
      let boxy = '';
      let bhyd = '';
      let brr = '';
      if (args.data.baseline && args.data.baseline.hrv && args.data.baseline.hrv.nominal) {
        bhrv = args.data.baseline.hrv.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.heartrate && args.data.baseline.heartrate.nominal) {
        bhr = args.data.baseline.heartrate.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.temperature && args.data.baseline.temperature.nominal) {
        btemp = args.data.baseline.temperature.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.oxygen && args.data.baseline.oxygen.nominal) {
        boxy = args.data.baseline.oxygen.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.hydration && args.data.baseline.hydration.nominal) {
        bhyd = args.data.baseline.hydration.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.respiratory && args.data.baseline.respiratory.nominal) {
        brr = args.data.baseline.respiratory.nominal.toFixed(1);
      }

      const thistooltip = new Tooltip({
        width: '400px',
        height: '200px',
        // <img src=${heartrate} style="display: inline-block;" width="30px" height="30px" />
        // ${args.data.bloodpressure ? args.data.bloodpressure.reading : ''}<sub class="supsm">sys/dia</sub>${bpflag}
        content: `<h1 style="text-align: center;">${args.data.name ? args.data.name.toUpperCase() : ''}: BIOMETRICS</h1><table class="biotable"><tbody><tr><th colspan="2">${riskLevel}</th><tr><td class="biometricsgrn"><sup class="supsm">hr</sup>${args.data.heartrate && args.data.heartrate.reading ? args.data.heartrate.reading : ''}<sub class="supsm">bpm</sub>${hrflag}<sup class="supsm">(${bhr})</sup></td><td class="biometricsltgrn">
      <sup class="supsm">hrv</sup>${args.data.hrv && args.data.hrv.reading ? args.data.hrv.reading : ''}<sub class="supsm">ms</sub>${hrvflag}<sup class="supsm">(${bhrv})</sup></td></tr><tr><td class="biometricsorn"><sub class="supsm">O<sup  class="supsm">2</sup></sub>${args.data.oxygen && args.data.oxygen.reading ? args.data.oxygen.reading : ''}<sub class="supsm">%</sub>${oflag}<sup class="supsm">(${boxy})</sup></td><td class="biometricsylw"><sup class="supsm">temp</sup>${args.data.temperature && args.data.temperature.reading ? args.data.temperature.reading : ''}<sub class="supsm">°F</sub>${tflag}<sup class="supsm">(${btemp})</sup></td></tr><tr><td class="biometricsblue"><sup class="supsm">hyd</sup>${args.data.hydration && args.data.hydration.reading ? args.data.hydration.reading : ''}<sub class="supsm">%</sub>${hflag}<sup class="supsm">(${bhyd})</sup></td><td class="biometricsblue"><sup class="supsm">rr</sup>${args.data.respiratory && args.data.respiratory.reading ? args.data.respiratory.reading : ''}<sub class="supsm">b/m</sub>${rrflag}<sup class="supsm">(${brr})</sup></td></tr></tbody></table>`,
      });
      if (colDisplay) {
        thistooltip.appendTo(args.cell);
      }
    }
  }
    */
  function recordingDevice(e) {
    if (!grid || !grid.current) {
      return;
    }
    if (e.target.itemData.value === 'na') {
      return;
    }
    setSelectedAudioOption(e.target.itemData.value);

    const selectedRecords = grid.current.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    const message = `"audio": "${e.target.itemData.value}"`;
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        dialogClick('na', 'Associate Audio Recording', 'An audio request sent!', null);
        setSelectedAudioOption('na');
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function oldsmsDevice(e) {
    if (!grid || !grid.current) {
      return;
    }
    if (!e) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd === 'na') {
      return;
    }
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} (${b.name}) or put device to sleep?`, 'restart');
      if (!message || message.length === 0) {
        return;
      }
      if (message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      message = '"fota":"ind"';
    } else if (cmd === 'checkin') {
      message = '"checkin":"ind"';
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
      // if (!confirm(`Send a LOCATE request to ${b.name}`)) {
      //  return;
      // }
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} (${b.name}) production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      if (message.includes('.') && !boss) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr":{"url":"bio.zackatlabs.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dialogClick('na', `Success ${cmd}`, responseJson.response, e);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function smsDevice(e) {
    if (!grid || !grid.current) {
      return;
    }
    if (!e) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd == 'na') {
      return;
    }
    if (cmd.length > 0 && cmd !== '""') {
      message = cmd;
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }

    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dialogClick('na', `Success ${cmd}`, responseJson.response, e);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function silenceDevice(e) {
    associate.silence = e;
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(associate),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dialogClick('na', 'SMS/Email Alerts', responseJson.response, null);
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const actionComplete = (args) => {
    const org = JSON.parse(localStorage.getItem('organization'));
    /** Set initial Focus */
    if (args.requestType === 'cancel') {
      setEvents(true);
    }
    if (args.requestType === 'beginEdit') {
      // args.form.elements.namedItem('name').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog && args.rowData && args.rowData.name) {
        dialog.header = `Details of ${args.rowData.name}`;
      }
    } else if (args.requestType === 'add') {
      args.form.elements.namedItem('name').focus();
    } else if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data && args.data.name.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = org.id;
          args.data.organization = org.name;
        }
        // Set Initial HIPAA
        const currentDate = new Date();
        const isoString = currentDate.toISOString();
        args.data.hipaa = { consent: true, timestamp: isoString, version: 'created' };
        if (args.data && args.data.device && args.data.device.length > 0 && (args.data.device.length < 19 || args.data.device.length > 20)) {
          dialogClick('na', 'Associate Profile', `Please provide a valid device for the associate ${args.data.device}!`, null);
          args.cancel = true;
          return;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Associate Action error ', responseJson.response, null);
              args.cancel = true;
            }
          })
          .catch((error) => {
            dialogClick('na', 'Associate Action error ', 'An error has occured during Insert!', null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch((error) => {
            dialogClick('na', 'Associate Action error', 'An error has occured during Update!', null);
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            dialogClick('na', 'Associate Action DELETE', `Associate ${selName} has been removed!`, null);
            setReload(!reload);
            setReloadCounts(reloadCounts - 1);
          })
          .catch((error) => {
            dialogClick('na', 'Associate Action error', 'An error has occured during Delete!', null);
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data || !data.user) {
      return;
    }
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.associates) {
      data.user.preferences.associates = {};
    }
    if (pref === 'group') {
      data.user.preferences.associates = { group: val, biometrics: data.user.preferences.associates.biometrics, condensed: data.user.preferences.associates.condensed, sort: data.user.preferences.associates.sort, limit: Number(limit) };
    } else if (pref === 'biometrics') {
      data.user.preferences.associates = { group: data.user.preferences.associates.group, biometrics: val, condensed: data.user.preferences.associates.condensed, sort: data.user.preferences.associates.sort, limit: Number(limit) };
    } else if (pref === 'condensed') {
      data.user.preferences.associates = { group: data.user.preferences.associates.group, condensed: val, biometrics: data.user.preferences.associates.biometrics, sort: data.user.preferences.associates.sort, limit: Number(limit) };
    } else if (pref === 'sort') {
      data.user.preferences.associates = { group: data.user.preferences.associates.group, biometrics: data.user.preferences.associates.biometrics, condensed: data.user.preferences.associates.condensed, sort: val, limit: Number(limit) };
    } else if (pref === 'limit') {
      data.user.preferences.associates = { group: data.user.preferences.associates.group, biometrics: data.user.preferences.associates.biometrics, condensed: data.user.preferences.associates.condensed, sort: data.user.preferences.associates.sort, limit: Number(val) };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', `Associates Preferences error ${pref}`, responseJson.response, null);
        }
        setReload(!reload);
      })
      .catch((error) => {
        navigate('/login');
      });
  }
  function handleChangeLimit(e) {
    setLimit(e.target.value);
    setUserPreferences('limit', e.target.value);
  }
  function changeColDisplay() {
    setColDisplay(!colDisplay);
    setUserPreferences('biometrics', !colDisplay);
  }
  function changeCondensed() {
    if (groups.length !== 0) {
      DialogUtility.alert('Please remove your grouping before changing the condensed view!');
      return;
    }
    setCondensed(!condensed);
    setUserPreferences('condensed', !condensed);
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      const sort = [];
      const currentSortSettings = grid.current.sortSettings;
      currentSortSettings.properties.columns.forEach((element) => {
        sort.push(element.properties);
      });
      setUserPreferences('sort', sort);
      // }
    }
    if (!grid || !grid.current || !grid.current.columns) {
      return;
    }
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Image' || col.headerText === 'Events' || col.headerText === 'Supervisor') {
        col.allowEditing = false;
      }
      if (col.headerText == 'Risk' || col.headerText == 'Environment') {
        col.visible = true;
      }
      if (args.requestType == 'add' && col.headerText === 'ID') {
        col.visible = false;
      }
      if (args.requestType == 'add' && col.headerText === 'Organization') {
        // col.visible = false;
      }
      if (args.requestType == 'filter' && (col.headerText == 'Image' || col.headerText == 'Name' || col.headerText == 'Device'
        || col.headerText == 'Organization' || col.headerText == 'Job Task' || col.headerText == 'MSN')) {
        col.visible = true;
      } else if (args.requestType == 'filter' && (col.headerText == 'Temperature' || col.headerText == 'Bloodpressure'
        || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue'
        || col.headerText == 'Activity')) {
        col.visible = colDisplay;
      } else if (args.requestType == 'beginEdit') {
        setEvents(false);
        if (col.headerText == 'Risk' || col.headerText == 'Environment' || col.headerText == 'Image' || col.headerText == 'Man Down' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure' || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'Hydration' || col.headerText == 'HR Variability' || col.headerText == 'Fatigue' || col.headerText == 'Activity' || col.headerText == 'ID') {
          col.visible = false;
        } else {
          col.visible = true;
        }
      } else if (args.requestType == 'add') {
        if (col.headerText == 'Risk' || col.headerText == 'Environment' || col.headerText == 'Man Down' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure' || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue' || col.headerText == 'Activity') {
          col.visible = false;
        } else {
          col.visible = true;
        }
      } else if (col.headerText == 'Image' || col.headerText == 'Name' || col.headerText == 'Device' || col.headerText == 'MSN' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure'
        || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue'
        || col.headerText == 'Activity' || col.headerText == 'Man Down' || col.headerText == 'Organization' || col.headerText == 'Job Task' || col.headerText == 'Risk' || col.headerText == 'Environment') {
        col.visible = true;
      } else {
        col.visible = false;
      }
      if (col.headerText === 'Language') {
        col.visible = true;
      }
      if (col.headerText === 'Device' || col.headerText === 'MSN') {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add') && args.type === 'actionBegin') {
          col.visible = true;
        } else {
          col.visible = true;
        }
      }
      if (col.headerText === 'Job Task') {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add') && args.type === 'actionBegin') {
          col.visible = true;
        }
      }
    }
  };
  function completeUpload(args) {
    dialogClick('na', 'Upload success', 'Your upload is complete!', null);
    setReload(!reload);
  }
  useEffect(() => {
    if (data.role && data.role.associates) {
      if (data.role.associates.permissions.includes('Create')) {
        setCrudCreate(true);
      }
      if (data.role && data.role.associates) {
        if (data.role.associates.permissions.includes('Import')) {
          setCrudImport(true);
        }
      }
      if (data.role.associates.permissions.includes('Update')) {
        setCrudUpdate(true);
      }
      if (data.role.associates.permissions.includes('Delete')) {
        setCrudDelete(true);
      }
      if (data.role.associates.permissions.includes('SST')) {
        setIsSST(true);
      }
      if (data.role.associates.permissions.includes('Duress')) {
        setIsDuress(true);
      }
    }
  }, [data]);
  useEffect(() => {
    if (grid && grid.current) {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        const row = grid.current.getSelectedRowIndexes();
        if (amapActive) {
          grid.current.selectRow(row[0], 1);
          setEvents(true);
          setDelete(true);
        } else {
          selectedRecords[0].source = 'controlpanel';
          setAssociate(selectedRecords[0]);
          setName(selectedRecords[0].name);
          setAddress(selectedRecords[0].address);
          setAddress1(selectedRecords[0].address1);
          setCity(selectedRecords[0].city);
          setState(selectedRecords[0].state);
          setZip(selectedRecords[0].zip);
          setGetManager(!getManager);

          if (selectedRecords[0].silence) {
            setMuted(true);
          } else {
            setMuted(false);
          }

          if (selectedRecords[0].risk) {
            if (selectedRecords[0].risk < 0) {
              setHypoColor('cyan');
              setBaseColor('transparent');
              setModerateColor('transparent');
              setElevatedColor('transparent');
              setSevereColor('transparent');
            } else if (selectedRecords[0].risk === '' || selectedRecords[0].risk < 25) {
              setHypoColor('transparent');
              setBaseColor('cyan');
              setModerateColor('transparent');
              setElevatedColor('transparent');
              setSevereColor('transparent');
            } else if (selectedRecords[0].risk < 50) {
              setHypoColor('transparent');
              setBaseColor('transparent');
              setModerateColor('cyan');
              setElevatedColor('transparent');
              setSevereColor('transparent');
            } else if (selectedRecords[0].risk < 80) {
              setHypoColor('transparent');
              setBaseColor('transparent');
              setModerateColor('transparent');
              setElevatedColor('cyan');
              setSevereColor('transparent');
            } else {
              setHypoColor('transparent');
              setBaseColor('transparent');
              setModerateColor('transparent');
              setElevatedColor('transparent');
              setSevereColor('cyan');
            }
          }
        }
      } else if (selectedRecords.length > 1) {
        setDelete(false);
      } else {
        setEvents(true);
      }
    }
  }, [dataChanged, amapActive]);
  /*
  const removeSticky = () => {
    if (grid && grid.scrollModule) {
      const gridElement = grid.current?.element;
      document.removeEventListener(
        'scroll',
        grid.current.scrollModule.makeStickyHeader,
      );
    }
  };
  */
  function rowClicked(args) {
    if (args) {
      if (args.rowData && args.rowData.jobtask) {
        const result = taskData.find(({ id }) => id === args.rowData.jobtask);
        if (result) {
          setJobTask(result.id);
        }
      } else {
        setJobTask('');
      }
      setManagerId(args.rowData.managerid);
      setAssociateId(args.rowData._id);
      setPatientId(args.rowData._id);
      setManagers(args.rowData.managers);
      setAssociateRow(args.rowIndex + 1);
      setAssociate(args.rowData);
      setEvents(false);
      setDelete(false);
      setDataChanged(!dataChanged);
    } else {
      setEvents(true);
    }
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/associatesremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/associatesupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      dialogClick('na', 'Organization not found on File Upload', 'Invalid Organization', null);
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  /*
  const FilterOptions = {
    type: 'FilterBar',
    showFilterBarStatus: true,
    mode: 'Immediate',
  };
  */
  const FilterOptions = {
    type: 'Menu',
  };
  const watchGrid = (props) => {
    const myid = `watch_${props._id}`;
    return (
      <div>
        <CheckBoxComponent label="Watch List" id={myid} checked={props.watch} onChange={handleWatchChange} />
      </div>
    );
  };

  const clickHandler = (args) => {
    if (timerid.current) {
      timerid.current = clearTimeout(timerid.current);
    }
    if (!args || !args.item || !args.item.properties || !args.item.properties.text) {
      return;
    }
    if (grid && grid.current && args.item.properties.text === 'Location') {
      setGMapDialog(!gmapDialog);
    } else if (grid && grid.current && args.item.properties.text === 'Charts') {
      setChartsDialog(!chartsDialog);
    } else if (grid && grid.current && args.item.properties.text === 'DevLogs') {
      setDevlogDialog(!devlogDialog);
    } else if (grid && grid.current && args.item.properties.text === 'Search') {
      const selectedRecords = grid.current.getSelectedRecords();
      setAssociateSearch(selectedRecords[0].name);
    } else if (grid && grid.current && args.item.properties.text === 'Events') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Events handler', 'Please select an associate!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setEventDialog(!eventDialog);
        //        navigate(`../events?id=${selectedRecords[0]._id}&lat=${selectedRecords[0].latlng.latitude}&lng=${selectedRecords[0].latlng.longitude}&name=${selectedRecords[0].name}`);
      } else {
        dialogClick('na', 'Events handler', 'Please select only one associate!', null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'STT') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'STT Events handler', 'Please select an associate!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setSSTEventDialog(!sstEventDialog);
        //        navigate(`../events?id=${selectedRecords[0]._id}&lat=${selectedRecords[0].latlng.latitude}&lng=${selectedRecords[0].latlng.longitude}&name=${selectedRecords[0].name}`);
      } else {
        dialogClick('na', 'STT handler', 'Please select only one associate!', null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Duress') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Duress Events handler', 'Please select an associate!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setDuressEventDialog(!duressEventDialog);
        //        navigate(`../events?id=${selectedRecords[0]._id}&lat=${selectedRecords[0].latlng.latitude}&lng=${selectedRecords[0].latlng.longitude}&name=${selectedRecords[0].name}`);
      } else {
        dialogClick('na', 'STT handler', 'Please select only one associate!', null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Configuration') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Configuration handler', 'Please select an associate!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setCollapseConfiguration(false);
        setCfgDialog(!cfgDialog);
      } else {
        dialogClick('na', 'Configuration handler', 'Please select only one associate!', null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      grid.current.deleteRecord(selectedRow);
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (isMobile) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        grid.current.startEdit(selectedRow);
      } else if (selectedRecords && selectedRecords.length > 0) {
        setAssociate(selectedRecords[0]);
        setRisk(selectedRecords[0].risk);
        setEnvironment(selectedRecords[0].environment);
        setDevice(selectedRecords[0].device);
        setMobile(selectedRecords[0].mobile);
        setEmail(selectedRecords[0].email);
        setReportsTo(selectedRecords[0].reportsTo);
        setJobTask(selectedRecords[0].jobtask);
        setDob(selectedRecords[0].dob);
        setSMSOptin(selectedRecords[0].smsOptin);
        setEmailOptin(selectedRecords[0].emailOptin);
        setGender(selectedRecords[0].gender);
        setEmployeeImage(selectedRecords[0].employeeImage);
        setLanguage(selectedRecords[0].language);
        setBundle(selectedRecords[0].alertBundle);
        setEngineering(selectedRecords[0].engineering);
        setRefresh(selectedRecords[0].refresh);
        setOrganization(selectedRecords[0].organizationid);
        setAssociateId(selectedRecords[0]._id);
        setPatientId(selectedRecords[0]._id);

        let vitals = '';
        if (selectedRecords[0].temperature && selectedRecords[0].temperature.reading && selectedRecords[0].temperature.timestamp) {
          vitals = `Temperature ${format(parseISO(selectedRecords[0].temperature.timestamp), 'yyyy-MM-dd hh:mm')} \r\n${selectedRecords[0].temperature.reading} °F`;
          if (selectedRecords[0].baseline && selectedRecords[0].baseline.temperature && selectedRecords[0].baseline.temperature.nominal) {
            vitals += `\tBaseline ${selectedRecords[0].baseline.temperature.nominal.toFixed(1)} °F\r\n`;
          } else {
            vitals += '\tBaseline °F\r\n';
          }
        }
        if (selectedRecords[0].heartrate && selectedRecords[0].heartrate.reading && selectedRecords[0].heartrate.timestamp) {
          vitals += `Heartrate ${format(parseISO(selectedRecords[0].heartrate.timestamp), 'yyyy-MM-dd hh:mm')} \r\n${selectedRecords[0].heartrate.reading} bpm`;
          if (selectedRecords[0].baseline && selectedRecords[0].baseline.heartrate && selectedRecords[0].baseline.heartrate.nominal) {
            vitals += `\tBaseline ${selectedRecords[0].baseline.heartrate.nominal.toFixed(1)} bpm\r\n`;
          } else {
            vitals += '\tBaseline bpm\r\n';
          }
        }
        if (selectedRecords[0].oxygen && selectedRecords[0].oxygen.reading && selectedRecords[0].oxygen.timestamp) {
          vitals += `Oxygen ${format(parseISO(selectedRecords[0].oxygen.timestamp), 'yyyy-MM-dd hh:mm')} \r\n${selectedRecords[0].oxygen.reading} %`;
          if (selectedRecords[0].baseline && selectedRecords[0].baseline.oxygen && selectedRecords[0].baseline.oxygen.nominal) {
            vitals += `\tBaseline ${selectedRecords[0].baseline.oxygen.nominal.toFixed(1)} %\r\n`;
          } else {
            vitals += '\tBaseline %\r\n';
          }
        }
        if (selectedRecords[0].hydration && selectedRecords[0].hydration.reading && selectedRecords[0].hydration.timestamp) {
          vitals += `Hydration ${format(parseISO(selectedRecords[0].hydration.timestamp), 'yyyy-MM-dd hh:mm')} \r\n${selectedRecords[0].hydration.reading} %`;
          if (selectedRecords[0].baseline && selectedRecords[0].baseline.hydration && selectedRecords[0].baseline.hydration.nominal) {
            vitals += `\tBaseline ${selectedRecords[0].baseline.hydration.nominal.toFixed(1)} %\r\n`;
          } else {
            vitals += '\tBaseline %\r\n';
          }
        }
        setVitals(vitals);
        setDialog(false);
      } else {
        DialogUtility.alert('Please select an Associate!');
      }
    } else if (grid && grid.current && args.item.properties.text === 'Add') {
      setRisk('');
      setEnvironment('');
      setName('');
      setDevice('');
      setMobile('');
      setEmail('');
      setReportsTo('');
      setJobTask('');
      setAddress('');
      setAddress1('');
      setCity('');
      setState('');
      setZip('');
      setDob('');
      setSMSOptin(false);
      setEmailOptin(false);
      setGender('');
      setEmployeeImage('https://monaco.zackat.com/blank.png');
      setLanguage(null);
      setBundle('');
      setEngineering(false);
      setRefresh('');
      setOrganization(null);
      setAssociate(null);
      setAssociateId('add_associate');
      setPatientId('');
      setVitals('');
      setDialog(false);
    } else if (grid && grid.current && args.item.properties.text === 'Invite') {
      const selectedRecords = grid.current.getSelectedRecords();
      const recipient = prompt('Please enter the email address of the Associate that you would like to receive the invitation!', selectedRecords[0].email);
      if (recipient) {
        fetch(`${REACT_APP_API_ENDPOINT}/invite?associateid=${selectedRecords[0]._id}&recipient=${recipient}&email=${usr.email}`, {
          method: 'GET',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Invite handler', responseJson.response, null);
              args.cancel = true;
            }
          })
          .catch((error) => {
            dialogClick('na', 'Invite handler', 'An error has occured during Invitation request!', null);
            args.cancel = true;
          });
      }
    } else if (grid && args.item.properties.text === 'AI') {
      setAIType('Predictive Analysis');
      handleClick('userFaq');
    } else if (grid && grid.current && args.item.properties.text === 'Mute') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && (!selectedRecords[0].silence || selectedRecords[0].silence === false)) {
        dialogClick('silence', 'SMS/Email Alerts', `Silence/Mute Alerts for ${selectedRecords[0].name} for everyone?`, null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'UnMute') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords[0].silence === true) {
        dialogClick('reinstate', 'SMS/Email Alerts', `Reinstate/Unmute alerts for ${selectedRecords[0].name} for everyone?`, null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Alerts') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Alerts handler', 'Please select an associate!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        const updateAssociate = async () => {
          selectedRecords[0].activity.alert = '';
          selectedRecords[0].oxygen.alert = '';
          selectedRecords[0].heartrate.alert = '';
          selectedRecords[0].hrv.alert = '';
          selectedRecords[0].temperature.alert = '';
          selectedRecords[0].hydration.alert = '';
          selectedRecords[0].bloodpressure.alert = '';
          const newData = selectedRecords[0];
          axios.defaults.headers.common.Authorization = `JWTToken ${usr.token}`;
          axios.put(
            `${REACT_APP_API_ENDPOINT}/associates?ack=true`,
            newData,
          ).then((response) => {
            // Handle the response
            // window.location.reload();
            dialogClick('na', 'Alerts', `acknowledged ${response.data.response}`, null);
            setReload(!reload);
            // data.associates = selectedRecords;
          })
            .catch((error) => {
              // Handle errors
              dialogClick('na', 'Alerts', `error ${error.message}`, null);
            });
        };
        updateAssociate();
      } else {
        dialogClick('na', 'Alerts handler', 'Please select only one associate!', null);
      }
    } else if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Associates_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      /*
      const properties = {
        fileName: `ExcelExport_Associates_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
      */
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/excel?${query}&associates=true`;
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      }).then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
          dialogClick('na', 'Associate Excel handler', responseJson.response, null);
        })
        .catch(() => {
        });
    }
  };
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    if (s && s.length > 0) {
      myScreenSize = `${s}px`;
    } else {
      myScreenSize = 'auto';
    }
  }
  /*
  if (!selectedOrg || !selectedOrg.id) {
    return <p>-- Please select and organization -- </p>;
  }
  */
  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.role && data.role.associates) {
    if (!data.role.associates.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }

  const editOptions = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  const editOptionsMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  if (data.organization) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  if (data.recordings) {
    data.recordings.forEach((rec) => {
      // const result = langData.find(({ id }) => id === rec.language);
      audioData.push({ value: rec._id, text: `${rec.name}` }); // (${result.value}) remove language
    });
  }

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(data.organization),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  const valuerules = { required: true };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Add_and_Edit_an_Associate_Record__QoqW0fE-RSmuyjr7lMp67A"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Operations" title="Associates" />
      </div>
      <div id="mapcontainer">
        <AMap dt={{ data }} />
      </div>
      {!condensed && !amapActive && (
        <div
          style={{
            backgroundColor: currentThemeColor,
            textAlign: 'right',
          }}
        >
          <div id="droparea">
            {crudImport && !isMobile && (
              <div className="control-section accordion-control-section" style={{ width: '45%' }}>

                <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                  <AccordionComponent>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                      <div className="e-input-group">
                        <div className="mt-4"> Import </div>
                      </div>
                      <div className="mt-2 e-input-group">
                        <div>
                          <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                        </div>
                        <UploaderComponent
                          id="fileupload"
                          type="file"
                          ref={(uplaod) => { uploadObj = uplaod; }}
                          asyncSettings={path}
                          buttons={buttons}
                          multiple={false}
                          actionComplete={completeUpload}
                          autoUpload={false}
                          uploading={onFileUpload}
                          allowedExtensions=".csv"
                        />
                      </div>
                    </div>
                  </AccordionComponent>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {!amapActive && (
        <div id="containerToolbar">
          <ToolbarComponent id="toolbar" onClick={onToolbarChange} overflowMode="MultiRow">
            <ItemsDirective>
              <ItemDirective text="Raw Events" float="left" prefixIcon="e-justify" visible={boss} disabled={!boss} />
              <ItemDirective type="Separator" />
              {biometricEnable && <ItemDirective template={biometricsComponent} />}
              {biometricEnable && <ItemDirective type="Separator" />}
              {smsEnable && <ItemDirective template={actionComponent} disabled={enableEvents} />}
              {smsEnable && <ItemDirective type="Separator" />}
              {recordingsEnable && <ItemDirective template={audioComponent} disabled={enableEvents} />}
              <ItemDirective text="Search" template={searchComponent} disabled={false} style={{ float: 'right !important' }} />
              <ItemDirective type="Separator" />
            </ItemsDirective>
          </ToolbarComponent>
          <ToolbarComponent id="toolbar" onClick={onToolbarChange}>
            <ItemsDirective>
              <ItemDirective template={pageComponent} float="left" />
              <ItemDirective type="Separator" />
            </ItemsDirective>
          </ToolbarComponent>
        </div>
      )}
      {!hideDialog && (
        <DialogComponent
          header={header}
          content={profileTemplate}
          buttons={associateid !== 'add_associate' ? savebuttons : addbuttons}
          width="55%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => {
            setAssociateId('');
            setPatientId('');
            setDialog(!hideDialog);
          }}
          close={() => { setDialog(!hideDialog); }}

        />
      )}
      {!eventDialog && (
        <DialogComponent
          header="Events"
          content={eventTemplate}
          buttons={eventsbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setEventDialog(!eventDialog); }}
          close={() => { setEventDialog(!eventDialog); }}
        />
      )}
      {!sstEventDialog && (
        <DialogComponent
          header="STT Events"
          content={sstEventTemplate}
          buttons={ssteventsbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setSSTEventDialog(!sstEventDialog); }}
          close={() => { setSSTEventDialog(!sstEventDialog); }}
        />
      )}
      {!duressEventDialog && (
        <DialogComponent
          header="Duress Events"
          content={duressEventTemplate}
          buttons={duresseventsbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setDuressEventDialog(!duressEventDialog); }}
          close={() => { setDuressEventDialog(!duressEventDialog); }}
        />
      )}
      {associate && !cfgDialog && (
        <DialogComponent
          header="Configuration"
          content={cfgTemplate}
          buttons={cfgbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setCfgDialog(!cfgDialog); }}
          close={() => { setCfgDialog(!cfgDialog); }}
        />
      )}
      {!gmapDialog && (
        <DialogComponent
          header="Map Location"
          content={gmapTemplate}
          buttons={gmapbuttons}
          width="65%"
          height="65%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setEventDialog(!gmapDialog); }}
          close={() => { setGMapDialog(!gmapDialog); }}
        />
      )}
      {!chartsDialog && (
        <DialogComponent
          header="Charts Week View"
          content={chartTemplate}
          buttons={chartbuttons}
          width="65%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setEventDialog(!chartsDialog); }}
          close={() => { setChartsDialog(!chartsDialog); }}
        />
      )}
      {boss && !devlogDialog && (
        <DialogComponent
          header="Device Logs"
          content={devlogTemplate}
          buttons={devlogbuttons}
          width="65%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setDevlogDialog(!chartsDialog); }}
          close={() => { setDevlogDialog(!chartsDialog); }}
        />
      )}

      {!amapActive && (
        <div className="e-adaptive-demo e-bigger">
          <div className="e-mobile-layout">
            <div className="e-mobile-content">
              <GridComponent
                ref={grid}
                id="assocGrid"
                dataSource={data.associates}
                width={myScreenSize}
                allowSorting
                allowMultiSorting
                allowResizing
                editSettings={editOptions}
                // filterSettings={FilterOptions}
                // allowFiltering
                toolbar={!isMobile ? toolbarOptions : toolbarNoOptions}
                // toolbarTemplate={toolbarTemplate}
                toolbarClick={clickHandler}
                dataBound={dataBound}
                sortSettings={sortOptions}
                actionComplete={actionComplete}
                actionBegin={actionBegin}
                queryCellInfo={customiseCell}
                enableStickyHeader={!isMobile}
                allowGrouping={!isMobile}
                groupSettings={groupOptions}
                allowTextWrap
                allowPdfExport
                allowExcelExport
                recordClick={rowClicked}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
                enableAltRow
                enablePersistence
                // selectionSettings={selectionSettings}
              >
                <ColumnsDirective>
                  {/*
                  <ColumnDirective
                    type="checkbox"
                    width="50"
                  />
                  */}
                  <ColumnDirective
                    field="_id"
                    headerText="ID"
                    visible={false}
                    isPrimaryKey
                  />
                  {!isMobile
                    && (
                      <ColumnDirective
                        field="employeeImage"
                        headerText="Image"
                        width="100"
                        visible={!isMobile}
                        allowGrouping={false}
                        allowSorting={false}
                        allowFiltering={false}
                        template={gridAssociateProfile}
                        headerTemplate={gridImageHeader}
                      />
                    )}
                  <ColumnDirective
                    field="name"
                    headerText="Name"
                    width="120"
                    visible
                    allowFiltering
                    allowGrouping={false}
                    textAlign="Left"
                    headerTemplate={gridNameHeader}
                    template={gridNameProfile}

                  />
                  {!condensed
                    && (
                      <ColumnDirective
                        field="risk"
                        headerText="Risk"
                        width="120"
                        visible={!isMobile}
                        allowFiltering={false}
                        textAlign="Left"
                        validationRules={{ min: -1, max: 100, maxLength: 3, minLength: 0 }}
                        headerTemplate={gridRiskHeader}
                      />
                    )}
                  {!condensed
                    && (
                      <ColumnDirective
                        field="environment"
                        headerText="Environment"
                        width="120"
                        visible={!isMobile}
                        allowFiltering={false}
                        textAlign="Left"
                        validationRules={{ min: -1, max: 100, maxLength: 3, minLength: 0 }}
                        headerTemplate={gridEnvHeader}
                      />
                    )}
                  {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                  {associatesGrid.map((item, index) => <ColumnDirective key={index} visible={colDisplay} {...item} />)}
                  {!condensed
                    && (
                      <ColumnDirective
                        field="organizationid"
                        headerText="Organization"
                        width="150"
                        textAlign="Left"
                        editType="dropdownedit"
                        headerTemplate={gridOrgHeader}
                        validationRules={valuerules}
                        visible
                        foreignKeyField="_id"
                        foreignKeyValue="title"
                        dataSource={organizations.params.dataSource}
                      />
                    )}
                  {!condensed
                    && (
                      <ColumnDirective
                        field="language"
                        headerText="Language"
                        width="150"
                        visible={!isMobile}
                        textAlign="Left"
                        editType="dropdownedit"
                        headerTemplate={gridLangHeader}
                        foreignKeyField="id"
                        foreignKeyValue="value"
                        dataSource={langParams.params.dataSource}
                      />
                    )}
                  {colDisplay && (
                    <ColumnDirective
                      field="temperature.reading"
                      headerText="Temperature"
                      width="120"
                      visible
                      textAlign="Left"
                      headerTemplate={gridTemperatureHeader}
                      valueAccessor={valueAccess}
                      template={gridTemperatureProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="bloodpressure.reading"
                      headerText="Bloodpressure"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridBloodpressureHeader}
                      valueAccessor={valueAccess}
                      template={gridBloodpressureProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="oxygen.reading"
                      headerText="Oxygen"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridOxygenHeader}
                      valueAccessor={valueAccess}
                      template={gridOxygenProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="hydration.reading"
                      headerText="Hydration"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridHydrationHeader}
                      valueAccessor={valueAccess}
                      template={gridHydrationProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="heartrate.reading"
                      headerText="Heartrate"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridHeartrateHeader}
                      valueAccessor={valueAccess}
                      template={gridHeartrateProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="hrv.reading"
                      headerText="HR Variability"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridHeartrateVariablilityHeader}
                      valueAccessor={valueAccess}
                      template={gridHRVProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="activity.reading"
                      headerText="Fatigue"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridFatigueHeader}
                      valueAccessor={valueAccess}
                      template={gridFatigueProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="activity.reading"
                      headerText="Man Down"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridManDownHeader}
                      valueAccessor={valueAccess}
                      template={gridManDownProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="respiratory.reading"
                      headerText="Respiratory"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridRespiratoryHeader}
                      valueAccessor={valueAccess}
                      template={gridRespiratoryProfile}
                    />
                  )}
                  {colDisplay && (
                    <ColumnDirective
                      field="activity.reading"
                      headerText="Activity"
                      width="120"
                      visible={colDisplay}
                      textAlign="Left"
                      headerTemplate={gridActivityHeader}
                      valueAccessor={valueAccess}
                      template={gridActivityProfile}
                    />
                  )}
                  {/*
                  <ColumnDirective
                    field="watch"
                    headerText="Watch"
                    width="80"
                    clipMode="EllipsisWithTooltip"
                    textAlign="Left"
                    visible
                    template={watchGrid}
                  />
                  */}
                </ColumnsDirective>
                <Inject services={[Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport, ForeignKey, Group, LazyLoadGroup, VirtualScroll]} />
              </GridComponent>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AssociatesControlCenter;
